import {HTMLAttributes} from 'react';
import {TabPositionControl} from '../../design-system/atoms/TabPositionControl/TabPositionControl';
import {MOBILE_LAYOUT_ID} from '../../design-system/layout/constant';
import {PortalSelectorHeadless} from '../headless/PortalSelectorHeadless';

interface Props extends HTMLAttributes<HTMLDivElement> {
  depth: number;
  disabled?: boolean;
  forceSticky?: boolean;
  isMobile: boolean;
  isWebView: boolean;
}

export const TabPositionSticky = ({
  children,
  depth,
  disabled,
  forceSticky = true,
  isMobile,
  isWebView,
  ...rest
}: Props) => {
  if (isMobile) {
    return (
      <PortalSelectorHeadless selectorId={MOBILE_LAYOUT_ID}>
        {children}
      </PortalSelectorHeadless>
    );
  }

  return (
    <TabPositionControl
      isMobile={isMobile}
      isWebView={isWebView}
      depth={depth}
      disabled={disabled}
      forceSticky={forceSticky}
      {...rest}
    >
      {children}
    </TabPositionControl>
  );
};
